export function downloadBlob(data: Blob, filename: string): void {
  const hiddenElement = document.createElement('a');
  const url = window.URL || window.webkitURL;

  hiddenElement.href = url.createObjectURL(data);
  hiddenElement.target = '_blank';
  hiddenElement.download = filename;
  hiddenElement.click();
}
